"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputHintDiv = exports.HelpTextDiv = exports.VisibilityTooltip = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const KeyVerticalOutlineIcon_1 = require("@tableau/icons/KeyVerticalOutlineIcon");
const NotificationInfoOutlineIcon_1 = require("@tableau/icons/NotificationInfoOutlineIcon");
const RESERVEDDatasourceCanInfoIcon_1 = require("@tableau/icons/RESERVEDDatasourceCanInfoIcon");
const RESERVEDDatasourceCanWarningIcon_1 = require("@tableau/icons/RESERVEDDatasourceCanWarningIcon");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const StyleFunctions_1 = require("../../style/StyleFunctions");
const LabelStyles_1 = require("../LabelStyles");
function VisibilityTooltip(props) {
    return (react_1.default.createElement(widgets_1.Tooltip, { tooltipContent: react_1.default.createElement(VisibilityTooltipContent, Object.assign({}, props)), position: widgets_1.TooltipPosition.BottomRightCorner, maxWidth: 350 },
        react_1.default.createElement("div", { style: { paddingLeft: '4px', display: 'inline-flex', position: 'relative', top: '4px' } },
            react_1.default.createElement(NotificationInfoOutlineIcon_1.NotificationInfoOutlineIcon, { size: LabelStyles_1.LabelStyles.INFO_ICON_SIZE }))));
}
exports.VisibilityTooltip = VisibilityTooltip;
function VisibilityTooltipContent(props) {
    var _a;
    const isSensitive = (_a = props.isSensitivity) !== null && _a !== void 0 ? _a : false;
    return (react_1.default.createElement("div", { style: { marginRight: '8px' } },
        props.isLabelValue && react_1.default.createElement(Header, Object.assign({}, props)),
        react_1.default.createElement(SampleCompactInlineAlertWidget, { label: catalog_messages_1.Messages.labelStandardVisibility(), type: widgets_1.InlineAlertType.Info, isSensitive: isSensitive }),
        react_1.default.createElement(SampleCompactInlineAlertWidget, { label: catalog_messages_1.Messages.labelHighVisibility(), type: widgets_1.InlineAlertType.Warning, isSensitive: isSensitive, hint: react_1.default.createElement(Hint, Object.assign({}, props)) })));
}
function Header(props) {
    const tooltipHeaderMessage = props.isSensitivity
        ? catalog_messages_1.Messages.sensitiveLabelValueVisibilityHelpNote()
        : catalog_messages_1.Messages.labelValueVisibilityHelpNote();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HelpTextDiv, null,
            react_1.default.createElement("div", { style: { width: '100%', marginBottom: '8px' } }, tooltipHeaderMessage)),
        react_1.default.createElement("hr", { style: { color: widgets_1.TabStyles.Colors.L9, backgroundColor: widgets_1.TabStyles.Colors.L9, height: '1px solid' } })));
}
function Hint({ isLabelValue }) {
    const highVisibilityHelpNote = isLabelValue
        ? catalog_messages_1.Messages.labelValueHighVisibilityHelp()
        : catalog_messages_1.Messages.labelHighVisibilityHelp();
    return (react_1.default.createElement(HelpTextDiv, null,
        react_1.default.createElement("div", { style: { width: '100%', marginBottom: '8px' } }, highVisibilityHelpNote)));
}
function HelpTextDiv({ disabled, children }) {
    return react_1.default.createElement("div", { style: disabled ? { opacity: widgets_1.TabStyles.Opacity.Disabled } : undefined }, children);
}
exports.HelpTextDiv = HelpTextDiv;
function InputHintDiv({ disabled, children }) {
    return (react_1.default.createElement("div", { style: {
            fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
            color: widgets_1.TabStyles.Typography.Color.PrimaryLight,
            opacity: disabled ? widgets_1.TabStyles.Opacity.Disabled : undefined,
        } }, children));
}
exports.InputHintDiv = InputHintDiv;
function SampleCompactInlineAlertWidget({ type: alertType, label, hint, isSensitive }) {
    const isSevere = alertType === widgets_1.InlineAlertType.Warning;
    const [stickerType, icon] = getStickerColor(isSevere, isSensitive);
    return (react_1.default.createElement("div", { style: { marginBottom: '8px' } },
        react_1.default.createElement(HelpTextDiv, null, label),
        react_1.default.createElement(widgets_1.StickerWidget, { className: sampleInlineAlertWidgetStyles, stickerType: stickerType, icon: icon, style: { width: 'fitContent' } },
            react_1.default.createElement(HelpTextDiv, null, catalog_messages_1.Messages.labelSampleText())),
        hint && react_1.default.createElement(HelpTextDiv, null, hint)));
}
function getStickerColor(isSevere, isSensitive) {
    let stickerType;
    let icon;
    if (isSevere && isSensitive) {
        stickerType = 'violet';
        icon = react_1.default.createElement(KeyVerticalOutlineIcon_1.KeyVerticalOutlineIcon, { size: 14, color: '#9602CF', alt: catalog_messages_1.Messages.labelHighVisibility() });
    }
    else if (isSensitive) {
        stickerType = 'neutral';
        icon = react_1.default.createElement(KeyVerticalOutlineIcon_1.KeyVerticalOutlineIcon, { size: 14, color: '#595C5F', alt: catalog_messages_1.Messages.labelStandardVisibility() });
    }
    else if (isSevere) {
        stickerType = 'yellow';
        icon = react_1.default.createElement(RESERVEDDatasourceCanWarningIcon_1.RESERVEDDatasourceCanWarningIcon, { size: 14, color: '#AC4B02', alt: catalog_messages_1.Messages.labelHighVisibility() });
    }
    else {
        stickerType = 'blue';
        icon = react_1.default.createElement(RESERVEDDatasourceCanInfoIcon_1.RESERVEDDatasourceCanInfoIcon, { size: 14, color: '#05628A', alt: catalog_messages_1.Messages.labelStandardVisibility() });
    }
    return [stickerType, icon];
}
const sampleInlineAlertWidgetStyles = (0, StyleFunctions_1.cssClass)('data-quality-dialog-sample-inline-alert', {
    marginTop: '4px',
    marginBottom: '8px',
});
//# sourceMappingURL=LabelHelpTooltips.js.map